export const isMovingFromElement = (element: HTMLElement | null) => {
  return document.activeElement === element;
};
